import mara from "@/data/btc-hodl-position/mara.js";
import riot from "@/data/btc-hodl-position/riot.js";
import hut8 from "@/data/btc-hodl-position/hut8.js";
import bitf from "@/data/btc-hodl-position/bitf.js";
import hive from "@/data/btc-hodl-position/hive.js";
import argo from "@/data/btc-hodl-position/argo.js";
import btbt from "@/data/btc-hodl-position/btbt.js";
import hsshf from "@/data/btc-hodl-position/hsshf.js";

export default [
  { name: "mara", stats: mara },
  { name: "riot", stats: riot },
  { name: "hut8", stats: hut8 },
  { name: "bitf", stats: bitf },
  { name: "hive", stats: hive },
  { name: "argo", stats: argo },
  { name: "btbt", stats: btbt },
  { name: "hsshf", stats: hsshf },
]
